import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueToDecimal',
})
export class ValueToDecimalPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value?: string | null): string {
    if (value) {
      return this.decimalPipe.transform(+value / 1e12, '1.2-2') as string;
    }

    return '';
  }
}
